const CHANGE_PAGE_SIZE = 'CHANGE_PAGE_SIZE';
const CHANGE_SORTING = 'CHANGE_SORTING';
const CHANGE_VIEW_TYPE = 'CHANGE_VIEW_TYPE';
const UPDATE_PRODUCTS_COMPARE_SETTINGS = 'UPDATE_PRODUCTS_COMPARE_SETTINGS';
const SET_IS_COMPARISON_BAR_CLOSED = 'SET_IS_COMPARISON_BAR_CLOSED';

export {
  CHANGE_PAGE_SIZE,
  CHANGE_SORTING,
  CHANGE_VIEW_TYPE,
  SET_IS_COMPARISON_BAR_CLOSED,
  UPDATE_PRODUCTS_COMPARE_SETTINGS,
};
